import BlockLeftImage from "../components/BlockLeftImage";

import Block3Columns from "../components/Block3Columns";
import FixedHeader from "../components/FixedHeader";
import video from "../img/colaplamed/videocongreso2.mp4";
import logo from "../img/colaplamed/logo.png";
import imagen1 from "../img/colaplamed/cinchona.png";
import imagen2 from "../img/colaplamed/horchata.png";
import imagen3 from "../img/colaplamed/cafe.png";
import colaplamed from "../img/colaplamed/colaplamed.jpg";
import AreasTematicas from "../components/AreasTematicas";
import Comites from "../components/Comites";
import Inscripciones from "../components/Inscripciones";
import Inscripcion2 from "../components/Inscripcion2";
import SpeakerCard from "../components/SpeakerCard";

function Home() {
  return (
    <>
      <FixedHeader video={video}></FixedHeader>
      <Inscripciones></Inscripciones>
      <div className="bg1 relative-block">
        <div className="layout9">
          <BlockLeftImage
            src={logo}
            content={
              <>
                <h2>
                  <b> COLAPLAMED: </b>ciencia, cultura y saberes ancestrales de
                  las plantas medicinales
                </h2>
                <p>
                  {" "}
                  <b>
                    {" "}
                    El Congreso Latinoamericano de Plantas Medicinales
                    (COLAPLAMED){" "}
                  </b>{" "}
                  es un encuentro internacional anual dedicado a la ciencia y la
                  cultura de las plantas medicinales. Reúne a{" "}
                  <b>
                    {" "}
                    científicos, representantes culturales y conservadores de
                    diversos países
                  </b>{" "}
                  para compartir experiencias, intercambiar iniciativas y
                  conocer avances científicos, tecnológicos y de innovación
                  relacionados con el uso y la institucionalización de las
                  plantas medicinales en América Latina. Además,
                  <b>
                    {" "}
                    promueve la integración de investigadores, motiva a jóvenes
                    científicos y reconoce los conocimientos{" "}
                  </b>{" "}
                  de quienes trabajan en la conservación de estas especies.
                </p>
              </>
            }
          ></BlockLeftImage>
        </div>
      </div>

      <div id="inscripcioncongreso">
        <Inscripcion2></Inscripcion2>
      </div>

      <div className="bg1 padding2">
        <center>
          <div className="layout8">
          <h2 className="layout6"><b>Loja: </b>tierra de saberes ancestrales y riqueza natural</h2>
          <p>
            <b>
              {" "}
              Loja, reconocida por sus saberes ancestrales y su extraordinaria
              biodiversidad, es un territorio donde la naturaleza y el
              conocimiento humano se han desarrollado en armonía.{" "}
            </b>
            Sus montañas, valles y bosques albergan productos que forman parte
            de la identidad cultural de la región y que han contribuido al
            bienestar y la salud de las personas dentro y fuera del país.
          </p></div>
          <Block3Columns
            col1={
              <>
                <div className="icon150">
                  <img src={imagen1}></img>
                  <h3> La Cinchona</h3>
                  <p>
                    {" "}
                    <b> Árbol emblemático de los Andes lojanos,</b> representa
                    uno de los mayores aportes de esta tierra a la medicina
                    mundial. De su corteza se extrajo la quinina, principio
                    activo que permitió combatir la malaria y salvó millones de
                    vidas, marcando un hito en la historia de la salud pública y
                    la farmacología.
                  </p>
                </div>
              </>
            }
            col2={
              <>
                <div className="icon150">
                  <img src={imagen2}></img>

                  <h3>Horchata lojana</h3>
                  <p>
                    Elaborada a partir de una diversidad de plantas medicinales,
                    encarna la sabiduría popular transmitida de generación en
                    generación.
                    <b>
                      {" "}
                      Más que una bebida tradicional, la horchata es un símbolo
                      de la relación respetuosa entre las comunidades y su
                      entorno natural
                    </b>
                    , así como del valor terapéutico de la medicina tradicional
                    en la promoción de la salud integral.
                  </p>
                </div>
              </>
            }
            col3={
              <>
                <div className="icon150">
                  <img src={imagen3}></img>
                  <h3>Café</h3>
                  <p>
                    {" "}
                    <b>
                      {" "}
                      Loja es reconocida como ciudad de café de calidad, gracias
                      a territorios de altura, suelos privilegiados y el trabajo
                      de productores
                    </b>{" "}
                    que han hecho del café un producto emblemático, con aromas y
                    perfiles que reflejan el carácter de su gente y la
                    diversidad de sus paisajes. Este café, más que un cultivo,
                    representa cultura, innovación, economía local y una apuesta
                    por la excelencia.
                  </p>
                </div>
              </>
            }
          ></Block3Columns>{" "}
        </center>
      </div>
      <AreasTematicas></AreasTematicas>
      <SpeakerCard></SpeakerCard>
      <Comites></Comites>
      <div className="padding icon200">
        <center>
          {" "}
          <h2>
            En <b>alianza con</b>{" "}
          </h2>
          <img src={colaplamed}></img>
        </center>
      </div>
    </>
  );
}

export default Home;
